import { Component, OnInit } from '@angular/core';

import { Location } from '../location.model';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.scss']
})
export class LocationListComponent implements OnInit {

  public locations: Location[] = [];

  constructor(
    public locationService: LocationService
  ) { }

  ngOnInit(): void {
    this.locations = this.locationService.locations.slice();
    console.log(this);

    this.locationService.locationsSubject.subscribe( (locations) => {
      this.locations = locations;
    })
  }

}
